import { tableNodeTypes } from "prosemirror-tables";
import { Fragment, Node, NodeType, Slice } from "prosemirror-model";
import { EditorState, TextSelection, Transaction } from "prosemirror-state";

interface TableProps {
  state: EditorState;
  rowsCount: number;
  colsCount: number;
  withHeaderRow: boolean;
  cellContent: Node | null;
}
interface InsertTableProps extends TableProps {
  dispatch: (transaction: Transaction) => void;
}

function createTable({ state, rowsCount, colsCount, withHeaderRow, cellContent }: TableProps) {
  const types = tableNodeTypes(state.schema);
  const headerCells = [];
  const cells = [];
  const createCell = (cellType: NodeType, content: Node | null) =>
    content ? cellType.createChecked(null, content) : cellType.createAndFill();

  for (let index = 0; index < colsCount; index += 1) {
    const cell = createCell(types.cell, cellContent);

    if (cell) {
      cells.push(cell);
    }

    if (withHeaderRow) {
      const headerCell = createCell(types.header_cell, cellContent);

      if (headerCell) {
        headerCells.push(headerCell);
      }
    }
  }

  const rows = [];

  for (let index = 0; index < rowsCount; index += 1) {
    rows.push(types.row.createChecked(null, withHeaderRow && index === 0 ? headerCells : cells));
  }

  return types.table.createChecked(null, rows);
}

export default function insertTable({
  state,
  dispatch,
  rowsCount,
  colsCount,
  withHeaderRow,
  cellContent
}: InsertTableProps): void {
  const table = createTable({ state, rowsCount, colsCount, withHeaderRow, cellContent });
  const pBefore = state.schema.nodes.paragraph.createAndFill();
  const pAfter = state.schema.nodes.paragraph.createAndFill();
  const sliceElements: Node[] = [];

  if (pBefore) {
    sliceElements.push(pBefore);
  }
  sliceElements.push(table);
  if (pAfter) {
    sliceElements.push(pAfter);
  }
  const slice = new Slice(Fragment.fromArray(sliceElements), 0, 0);

  const startPos = state.selection.from;
  const tr = state.tr.replaceSelection(slice).scrollIntoView();
  const tablePos = pBefore ? startPos + pBefore.nodeSize : startPos;
  tr.setSelection(TextSelection.near(tr.doc.resolve(tablePos + 1)));

  dispatch(tr);
}
